import { ToastProvider } from 'braid-design-system';
import type React from 'react';

import { ErrorSectionWithLayout } from 'src/App/components/ErrorSection/ErrorSectionWithLayout';
import { CreateOrderProvider } from 'src/App/pages/checkout/context/CreateOrderProvider';
import { ProductSetProvider } from 'src/App/pages/checkout/context/ProductSetProvider';

import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';

import Checkout from './Checkout';
import { Provider as CheckoutProvider } from './context/provider';
// Component hierarchy ( high level )
// - CheckoutPage
//  - Checkout
//    - Confirmation
//    - BusinessAddressForm
//    - Selling Points
//    - LargerBudgetPurchaseAlert
//    - AdBudgetCheckout
//      - HirerOrderSummary
//      - PaymentWidget

const CheckoutPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <ErrorBoundary errorDisplay={<ErrorSectionWithLayout />}>
    <CheckoutProvider>
      <ProductSetProvider>
        <CreateOrderProvider>
          <ToastProvider>
            <Checkout />
          </ToastProvider>
        </CreateOrderProvider>
      </ProductSetProvider>
    </CheckoutProvider>
  </ErrorBoundary>
);

export default CheckoutPage;
